import { Sparkles, X } from 'lucide-react';
import { useState } from 'react';

export function ChangelogBanner() {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;

  return (
    <div className="relative rounded-[22px] border border-[var(--warm-border)] bg-[var(--warm-card)] p-4 mb-8 overflow-hidden">
      <div className="absolute right-0 top-0 -mt-8 -mr-8 size-32 rounded-full bg-[#E7C9A3]/20 blur-2xl" />
      <div className="flex items-start gap-3 relative">
        <div className="rounded-xl bg-[var(--warm-surface)] p-2 shrink-0">
          <Sparkles className="size-4 text-[#1C1A15]" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold text-zinc-900 ">
            What's new
          </p>
          <div className="mt-1.5 space-y-1">
            <p className="text-xs text-zinc-600 ">
              <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-[var(--warm-inv)] text-[var(--warm-inv-text)] font-medium text-[10px] mr-1.5">NEW</span>
              Ticket Merging, Bulk Actions & Realtime Comments
            </p>
            <p className="text-xs text-zinc-600 ">
              <span className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-[var(--warm-surface)] text-[var(--chip-green)] border border-[var(--warm-border)] font-medium text-[10px] mr-1.5">JUL 2026</span>
              Public API — Members & Webhooks endpoints now available
            </p>
          </div>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="p-1 rounded-md text-zinc-400 hover:text-zinc-600 hover:bg-[var(--warm-surface)]/50 transition-colors shrink-0"
        >
          <X className="size-4" />
        </button>
      </div>
    </div>
  );
}
